interface Country {
	dialCode?: string;
	code: string;
}
export default function splitNumberAndDialCode(
	str = '',
	countries: Country[] = [],
	dialCode?: string
) {
	if (dialCode) {
		return {
			number: str.replace(dialCode, ''),
			dialCode: dialCode,
			iso2: countries.find(country => country.dialCode === dialCode)?.code || '',
		};
	}
	const countriesByDialCode = countries.reduce((acc: { [key: string]: Country }, curr) => {
		if (curr.dialCode) {
			return {
				...acc,
				[curr.dialCode]: acc[curr.dialCode] ? [acc[curr.dialCode], curr][0] : curr,
			};
		} else {
			return acc;
		}
	}, {});

	const [longestDialCode = []] = Object.keys(countriesByDialCode).sort(
		(a = '', b = '') => b.length - a.length
	);

	const country: Country = (n => {
		let i = n;
		while (i > 0) {
			const x = str.substring(0, i);
			if (countriesByDialCode[x]) {
				return countriesByDialCode[x];
			}
			i -= 1;
		}
		return { dialCode: '', code: '' } as Country;
	})(longestDialCode.length);

	return {
		number: str.replace(country?.dialCode || '', ''),
		dialCode: country?.dialCode || '',
		iso2: country?.code || '',
	};
}
